import { render, staticRenderFns } from "./RepresentacionRechazar.vue?vue&type=template&id=5cc41ac6&scoped=true&"
import script from "./RepresentacionRechazar.vue?vue&type=script&lang=js&"
export * from "./RepresentacionRechazar.vue?vue&type=script&lang=js&"
import style0 from "./RepresentacionRechazar.vue?vue&type=style&index=0&id=5cc41ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc41ac6",
  null
  
)

component.options.__file = "RepresentacionRechazar.vue"
export default component.exports